import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as l, useCssModule as n, computed as d, createBlock as m, openBlock as c, resolveDynamicComponent as p, normalizeClass as u, unref as f, withCtx as C, renderSlot as v } from "vue";
import s from "../../utils/propValidator.mjs";
const a = "cdr-list", h = /* @__PURE__ */ l({
  name: "CdrList",
  __name: "CdrList",
  props: {
    /**
     * Sets list type and HTML element as "unordered" or "ordered"
     * @values ul, ol
     */
    tag: {
      type: String,
      default: "ul",
      validator: (e) => s(e, ["ul", "ol"])
    },
    /**
     * Modifies the style variant for this component
     * @demoSelectMultiple true
     * @values ordered, unordered, compact, inline
     */
    modifier: {
      type: String,
      default: void 0,
      validator: (e) => s(e, ["ordered", "unordered", "compact", "inline"])
    }
  },
  setup(e) {
    const o = e, r = n(), i = d(() => o.modifier ? o.modifier.split(" ").map((t) => r[`${a}--${t}`]) : "");
    return (t, g) => (c(), m(p(e.tag), {
      class: u([f(r)[a], i.value])
    }, {
      default: C(() => [v(t.$slots, "default")]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  h as default
};
